/**
 * Dashboard utilities for transforming raw API data into presentation format.
 */

/**
 * Format a date to month label (e.g., "Jan 2026").
 */
export function formatMonthLabel(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
}
